import {productCardOptimization} from './constants/signalmanConstants';

export default function productCardOptimizationEnabled(iframer) {
  return productCardOptimization === 'test' && !iframer;
}
